"use client";
import { UserType } from "@/@types/response";
import ROUTES from "@/config/routes";
import { useAuthStore } from "@/store/authStore";
import { useGeneralStore } from "@/store/generalStore";
import { useGeolocationStore } from "@/store/geolocationStore";
import { showToast } from "@/utils/alert";
import { getFingerprint, getUUID } from "@/utils/helper";
import { Session } from "next-auth";
import { signOut, useSession } from "next-auth/react";
import { usePathname } from "next/navigation";
import React, { useEffect, useState } from "react";
import OneSignal from "react-onesignal";

const Scripts = (params: { session: Session; user: UserType | null }) => {
  const path = usePathname();
  const { status } = useSession();
  const logout = useAuthStore((state) => state.signOut);
  const getProfile = useAuthStore((state) => state.getProfile);
  const setProfile = useAuthStore((state) => state.setProfile);
  const role = useAuthStore((state) => state.role);
  const profile = useAuthStore((state) => state.profile);
  const setSubscriberId = useAuthStore((state) => state.setSubscriberId);
  const getConstant = useGeneralStore((state) => state.getConstant);
  const setLocation = useGeolocationStore((state) => state.setLocation);
  const { getMenu } = useGeneralStore();

  const handleInitDeviceIdentity = async () => {
    await getUUID();
    await getFingerprint();
    await getConstant();
    await setLocation();
  };

  useEffect(() => {
    setTimeout(() => {
      handleInitDeviceIdentity();
    }, 1000);
  }, []);

  useEffect(() => {
    handleInitOneSignal();
  }, []);

  useEffect(() => {
    if (params.user) {
      setProfile(params.user);
    } else {
      if (status == "authenticated") {
        setTimeout(() => {
          handleGetAccountDetail();
        }, 3000);
      }
    }
  }, [params.user, status]);

  useEffect(() => {
    if (role) getMenu();
  }, [role]);

  async function handleGetAccountDetail() {
    if (path != ROUTES.AUTH.LOGIN()) {
      setTimeout(async () => {
        const profile_result = await getProfile();
        if (profile_result != true) {
          showToast({
            title: (profile_result as string) || "Terjadi kesalahan",
            icon: "error",
          });
          logout();
          signOut({ callbackUrl: ROUTES.AUTH.LOGIN() });
        }
      }, 3000);
    }
  }

  async function handleInitOneSignal() {
    if (typeof window !== "undefined") {
      await OneSignal.init({
        allowLocalhostAsSecureOrigin: true,
        appId: process.env.NEXT_PUBLIC_ONE_SIGNAL_APP_ID!,
        persistNotification: true,
        notifyButton: {
          enable: true,
          prenotify: true,
          showCredit: true,
          text: {
            "dialog.blocked.message":
              "Aktifkan izin notifikasi di browser agar tidak ketinggalan update penting dari CRM.",
            "dialog.blocked.title": "Notifikasi Diblokir",
            "dialog.main.button.subscribe": "Aktifkan Notifikasi",
            "dialog.main.button.unsubscribe": "Matikan Notifikasi",
            "dialog.main.title": "Dapatkan Update CRM Secara Langsung",
            "message.action.resubscribed":
              "Notifikasi CRM sudah aktif kembali.",
            "message.action.subscribed":
              "Berhasil berlangganan notifikasi CRM.",
            "message.action.subscribing": "Mengaktifkan notifikasi...",
            "message.action.unsubscribed": "Notifikasi CRM sudah dimatikan.",
            "message.prenotify":
              "Klik lonceng untuk mendapatkan update terbaru CRM.",
            "tip.state.blocked": "Anda telah memblokir notifikasi.",
            "tip.state.subscribed": "Anda berlangganan notifikasi CRM.",
            "tip.state.unsubscribed": "Anda belum mengaktifkan notifikasi.",
          },
        },
      });
    }
  }

  async function handleSetOneSignalData() {
    if (typeof window !== "undefined") {
      OneSignal.User.PushSubscription.addEventListener("change", (event) => {
        if (event.current.optedIn && profile?.user?.msisdn) {
          if (profile?.user?.msisdn) {
            OneSignal.User.addSms(profile?.user?.msisdn);
            OneSignal.User.addTag("phone_number", profile?.user?.msisdn);
          }
          if (profile?.user?.email)
            OneSignal.User.addEmail(profile?.user?.email);
          OneSignal.User.addTag("email", profile?.user?.email);
        }
      });

      // if (profile?.user) OneSignal.login(profile?.user?.msisdn);
      console.log(OneSignal.User.PushSubscription);
      const subscriberId = OneSignal.User.PushSubscription?.id;
      if (subscriberId) setSubscriberId(subscriberId);
    }
  }
  useEffect(() => {
    if (profile) handleSetOneSignalData();
    console.log({ profile });
  }, [profile]);

  useEffect(() => {
    if (params.session) {
      handleGetAccountDetail();
    }
  }, [params.session, path]);
  return <></>;
};

export default Scripts;
